import ChooseAFileInDr from './ChooseAFileInDr.component';

export default ChooseAFileInDr;